import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useMutationPayInvoiceAsMember({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  const payInvoiceMutation = useMutation({
    mutationFn: async ({
      invoiceNumber,
      paymentMethodId,
    }: {
      invoiceNumber: string;
      paymentMethodId?: string;
    }) => {
      return (
        await api.profileApi.payPastDueInvoice(invoiceNumber, paymentMethodId)
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.all(),
      });
    },
  });

  return payInvoiceMutation;
}
